// FreshPurchasePostingModal.jsx
import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  Grid,
  MenuItem,
  TextField,
  Typography,
  Toolbar,
  IconButton,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import { getGlobals } from "../../Configs";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import { vRdxUserInfo } from "../../Redux/roStore";
import { fAlertToast } from "../../Utility/Utilitys";
import { CmpButtonV2 } from "../../Component/Common/ToolBox/ToolBox";

export default function PurchaseConsolidationModal({
  open,
  xCloseModal,
  xModalfullScreen,
  xModalHeight,
  data,
  setSelectedRow,
  setIsPopModalDataChanged,
  setTransferTrans,
  setConsolidationTrans,
  setPurchaseOrders,
  setType,
  setLoading,
  transferTrans,
  consolidationTrans,
  purchaseOrders,
  type,
  loading,
  fDetail,
  sType,
}) {
  const baseURL = getGlobals().API_BASE_URL;
  const toolbar = {
    backgroundColor: "#0d73bb",
    color: "white",
    display: "flex",
    justifyContent: "space-between",
    minHeight: "40px !important",
  };

  useEffect(()=>{
    if(open){
    fDetail();
    }

  },[open])
  const fPost = async () => {
    confirmAlert({
      title: "Post",
      message: "Are you sure to post this consolidation?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            setLoading(true);
            const vRdxUserInfoObj = vRdxUserInfo();
            try {
              const response = await axios.post(
                `${baseURL}PurchaseOrder/PUCNS01CONSLC_PURCHASE_POSTING_UPDATE`,
                {
                  A_VocTyp: data?.A_VocTyp,
                  A_VocNo: data?.A_VocNo,
                  A_PostDt: moment(data?.A_VocDt).format("MM/DD/YYYY"),
                  UserId: vRdxUserInfoObj?.UserID,
                  A_Br: data?.Br,
                  A_Type: type,
                }
              );
              if (response.status === 200) {
                fAlertToast("SUCCESS", "Consolidation posted successfully.");
                setSelectedRow((prev) => ({
                  ...prev,
                  Completed: "POST",
                }));
                fDetail();
                setIsPopModalDataChanged(true);
              } else {
                fAlertToast("FAILED", "Consolidation not posted");
              }
              setLoading(false);
            } catch (err) {
              console.log(err);
              const msg =
                err?.response?.data?.error ||
                err?.message ||
                "Consolidation not posted";

              fAlertToast("FAILED", msg);
              setLoading(false);
            }
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const fClose = () => {
    setPurchaseOrders([]);
    setConsolidationTrans([]);
    setTransferTrans([]);
    setType("All");
    xCloseModal();
  };

  const orderCols = useMemo(
    () => [
      { field: "Ord_ID", headerName: "Ord.ID", width: 120 },
      {
        field: "Ord_Date",
        headerName: "Ord.Date",
        width: 100,
        valueFormatter: (v) =>
          v?.value ? dayjs(v.value).format("DD/MM/YYYY") : "",
      },
      { field: "Ord_Loc_Name", headerName: "Location", width: 180 },
      { field: "Ord_Buyer_Name", headerName: "Buyer", width: 180 },
      { field: "Ord_Status", headerName: "Status", width: 80 },
    ],
    []
  );

  const consCols = useMemo(
    () => [
      { field: "TRNS_ID", headerName: "Trans.ID", width: 120 },
      {
        field: "TRNS_DATE",
        headerName: "Date",
        width: 100,
        valueFormatter: (v) =>
          v?.value ? dayjs(v.value).format("DD/MM/YYYY") : "",
      },
      { field: "TRNS_PARTY_NAME", headerName: "Vendor", width: 240 },
      { field: "Status", headerName: "Status", width: 80 },
      { field: "GRN_DOC_NO", headerName: "GRN.Doc.No", width: 130 },
      { field: "GRN_DOC_TYP_NAME", headerName: "PR.Doc.No", width: 260 },
      { field: "DOC", headerName: "Doc", width: 110 },
    ],
    []
  );

  const tsrCols = useMemo(
    () => [
      { field: "SR_No", headerName: "Sr.No", width: 60 },
      { field: "TSR_VocTypName", headerName: "Doc.Type", width: 260 },
      { field: "TSR_VocNo", headerName: "Doc.No", width: 140 },
    ],
    []
  );

  return (
    <Dialog
      open={open}
      onClose={fClose}
      maxWidth={xModalfullScreen ? "98%" : "lg"}
    >
      <Toolbar sx={toolbar}>
        <DialogTitle
          sx={{
            backgroundColor: "#0d73bb",
            color: "white",
            padding: "0 4px !important",
          }}
        >
          Purchase consolidation Posting
        </DialogTitle>
        <IconButton
          edge="end"
          color="inherit"
          onClick={fClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>
      <DialogContent sx={{ pb: 2, height: xModalHeight }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={5}>
            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <TextField
                  label="Doc.Type"
                  size="small"
                  fullWidth
                  value={`${data?.A_VocTyp} - ${data?.VocName || ""}`}
                  InputProps={{ readOnly: true }}
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Doc.No"
                  size="small"
                  fullWidth
                  value={data?.A_VocNo}
                  InputProps={{ readOnly: true }}
                  disabled
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Doc.Status"
                  size="small"
                  fullWidth
                  value={data?.A_DocStat}
                  disabled
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Com.Status"
                  size="small"
                  fullWidth
                  value={data?.Completed}
                  disabled
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Date"
                  size="small"
                  fullWidth
                  value={moment(data?.A_VocDt).format("DD/MM/YYYY")}
                  disabled
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Branch"
                  size="small"
                  fullWidth
                  value={`${data?.Br} - ${data?.BrName}`}
                  disabled
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  select
                  label="Type"
                  id="F_Type"
                  size="small"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  fullWidth
                >
                  {sType?.map((option) => (
                    <MenuItem key={option.Id} value={option.Id}>
                      {option.Name1}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} textAlign={"center"}>
                <CmpButtonV2
                  xbtnName="Post"
                  xOnClick={fPost}
                  xVariant="contained"
                  xSize="medium"
                  xDisabled={data?.Completed === "POST"}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Orders grid (top right) */}
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                height: 250,
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Purchase Orders
              </Typography>
              <DataGrid
                rows={purchaseOrders}
                columns={orderCols}
                loading={loading}
                hideFooter
                getRowId={(row) => row.Ord_ID}
                density="compact"
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#0d73bb",
                    color: "#fff",
                  },
                }}
              />
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Bottom: two side-by-side grids */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                height: 350,
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Consolidation Transactions
              </Typography>
              <DataGrid
                rows={consolidationTrans}
                columns={consCols}
                loading={loading}
                hideFooter
                density="compact"
                getRowId={(v) => v.TRNS_ID}
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#0d73bb",
                    color: "#fff",
                  },
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={5}>
            <Box
              sx={{
                height: 350,
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Transfer Transactions
              </Typography>
              <DataGrid
                rows={transferTrans}
                columns={tsrCols}
                loading={loading}
                hideFooter
                getRowId={(v) => v.SR_No}
                density="compact"
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#0d73bb",
                    color: "#fff",
                  },
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
